import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { BeFi20Icon } from '../../../../../BeFi20/img/BeFi20Icon';
import { BeFi20IconSelected } from '../../../../../BeFi20/img/BeFi20IconSelected';
import PulseCheckLogo from '../../../../../PulseCheck/img/tile-logo.svg';

interface Props {
  icon: 'befi20' | 'pulseCheck' | string;
  checked: boolean;
}

export const CustomIcon = ({ icon, checked }: Props) => {
  const renderIcon = () => {
    switch (icon) {
      case 'befi20':
        return checked ? <BeFi20IconSelected /> : <BeFi20Icon />;
      case 'pulseCheck':
        return <PulseCheckLogo width={24} />;
      default:
        throw new Error(`Unknown custom icon: ${icon}`);
    }
  };

  return (
    <Text color={checked ? 'primary.600' : 'neutral.500'} css="line-height: 0">
      {renderIcon()}
    </Text>
  );
};
